import Vue from 'vue';
// @ts-expect-error
import VueSliderComponent from 'vue-slider-component/dist-css/vue-slider-component.umd';

import 'vue-slider-component/dist-css/vue-slider-component.css';
import 'vue-slider-component/theme/default.css';

Vue.component('VueSlider', VueSliderComponent);
